// extracted by mini-css-extract-plugin
export default {"container":"cX-z","title":"dX-z","link":"eX-z"};